import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import { useEffect, useState } from "react";
import {IMAGE_URL} from "../path";
import { getGalleries } from "../actions/ApiCalls";
import { useNavigate } from "react-router-dom";

function Galleries() {
    const linkStyle: React.CSSProperties = {
        color: 'black',
        fontSize: '10px',
        fontFamily: "'Vinimark-Diatype', sans-serif",
        fontWeight: 600,
        textTransform: 'uppercase',
        textDecoration: 'underline',
        cursor: 'pointer',
    };

    const [galleries, setGalleries] = useState<any[]>([]);
    const imgUrl = IMAGE_URL;
    const navigate = useNavigate();

    const [screenSize, setScreenSize] = useState({
        width: window.innerWidth,
        isDesktop: window.innerWidth > 950,
        isTablet: window.innerWidth <= 950 && window.innerWidth > 575,
        isMobile: window.innerWidth <= 575
    });

    useEffect(() => {
        fetchGalleries();
        document.title = "Vinimark | Galleries";
    }, []);

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            setScreenSize({
                width,
                isDesktop: width > 950,
                isTablet: width <= 950 && width > 575,
                isMobile: width <= 575
            });
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    function fetchGalleries() {
        getGalleries()
            .then(response => {
                setGalleries(response.data.galleries || []);
            })
            .catch(e => {
                console.error("Failed to fetch galleries:", e);
                setGalleries([]); // ensure empty state on error
            });
    }

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            width: '100%',
        }}>
            <Header />

            <div style={{
                marginTop: '130px',
                display: "flex",
                flexDirection: screenSize.isMobile ? 'column' : 'row',
                gap: '20px'
            }}>
                <div style={{ flex: 1 }}></div>
                <div style={{
                    flex: 1,
                    textAlign: 'left',
                    paddingRight: '20px',
                    paddingLeft: screenSize.isMobile ? '20px' : '50px'
                }}>
                    <p style={{ fontWeight: 600 }}>GALLERIES</p>
                    <p style={{
                        width: screenSize.isMobile ? '95%' : '60%',
                        marginBottom: '10px',
                        fontWeight: 400
                    }}>
                        Explore moments captured through our lens — from vineyards and harvests to celebrations and partnerships. Each gallery offers a glimpse into the world of Vinimark, where passion and craftsmanship meet.
                    </p>
                    <p style={{ fontSize: '13px', marginBottom: '100px' }}>
                        <a style={linkStyle} href="/subscribe">Join our mailing list</a>
                    </p>
                </div>
            </div>

            {galleries.length === 0 ? (
                <div style={{
                    textAlign: 'center',
                    marginTop: '50px',
                    marginBottom: '100px',
                    fontSize: '14px',
                    fontWeight: 500,
                    minHeight: window.innerWidth <= 575 ? '0vh' : '15vh'
                }}>
                    <div style={{display: 'flex', justifyContent: 'center', marginBottom: '20px', flexDirection: window.innerWidth <= 575 ? 'column' : 'row' }}>
                        <div style={{flex: 1, textAlign: 'center'}}></div>
                        <div style={{flex: 1, textAlign: 'left', marginLeft: window.innerWidth <= 575 ? '16px' : '46px'}}>No galleries found.</div>
                    </div>

                </div>
            ) : (
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: screenSize.isDesktop
                        ? 'repeat(4, 1fr)'
                        : screenSize.isTablet
                            ? 'repeat(2, 1fr)'
                            : '1fr',
                    gap: screenSize.isMobile ? '25px' : '40px',
                    padding: screenSize.isMobile
                        ? '0'
                        : screenSize.isTablet
                            ? '0 30px'
                            : '0 50px',
                    marginBottom: '50px',

                }}>
                    {galleries.map((gallery, index) => (
                        <div
                            key={index}
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: screenSize.isMobile ? 'center' : 'flex-start',
                                marginBottom: screenSize.isMobile ? '25px' : '40px',
                                width: '100%',
                            }}
                        >
                            <div style={{
                                width: screenSize.isMobile ? '100vw' : '100%',
                                aspectRatio: '16/9',
                                overflow: 'hidden',
                                marginBottom: '20px',
                                position: screenSize.isMobile ? 'relative' : 'static',
                                left: screenSize.isMobile ? '50%' : '0',
                                transform: screenSize.isMobile ? 'translateX(-50%)' : 'none',
                            }}>
                                <img
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover'
                                    }}
                                    src={imgUrl + gallery.cover_image}
                                    alt={gallery.title || `Gallery ${index + 1}`}
                                />
                            </div>

                            <div style={{
                                width: screenSize.isMobile ? '90%' : '100%',
                                textAlign: 'left',
                            }}>
                                <p style={{
                                    fontSize: '13px',
                                    fontWeight: 600,
                                    marginTop: 0,
                                    textTransform: 'uppercase',
                                    marginBottom: '8px',
                                }}>
                                    {gallery.title}
                                </p>
                                {gallery.year && (
                                    <p style={{
                                        fontSize: '10px',
                                        fontWeight: 600,
                                        marginBottom: '12px'
                                    }}>
                                        {gallery.year}
                                    </p>
                                )}
                                {gallery.description && (
                                    <div style={{
                                        marginBottom: '15px',
                                        fontWeight: 400,
                                        fontSize: '12px'
                                    }}>
                                        {gallery.description}
                                    </div>
                                )}
                                <div>
                                    <a
                                        style={linkStyle}
                                        onClick={() => navigate(`/galleries/${gallery.search_title}`)}
                                    >
                                        view more
                                    </a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/*<div style={{ textAlign: 'center', marginBottom: '80px' }}>*/}
            {/*    <a*/}
            {/*        style={{*/}
            {/*            ...linkStyle,*/}
            {/*            display: 'block',*/}
            {/*            width: '100%',*/}
            {/*            textAlign: 'center',*/}
            {/*            paddingTop: '50px',*/}
            {/*            paddingBottom: '30px',*/}
            {/*        }}*/}
            {/*        href={'/subscribe'}*/}
            {/*    >*/}
            {/*        Join our newsletter*/}
            {/*    </a>*/}
            {/*</div>*/}

            <Footer />
        </div>
    );
}

export default Galleries;
